<template>
    <div class="login">
        <div class="login-header">
            <div class="login-title">欢迎登录</div>
                <div class="login-tip">智能云算力资源交易平台</div>
        </div>
        <div class="login-box">
            <div class="login-row">
                <input type="text" placeholder="请输入用户名" class="use" v-model="use.userName">
            </div>
            <div class="login-row">
                <input type="password" placeholder="请输入密码" class="use" v-model="use.passWord">
            </div>
            <button class="login-btn" @click="loginFunc">登 录</button>
            <button class="login-btn" @click="$router.push({path:'/'})">返 回</button>
        </div>
    </div>
</template>
<script>
import {
    login
} from '@/api/index'
import { Toast } from 'vant';
export default {
    data() {
        return {
            use: {
                userName: "",
                passWord: "",
            }
        }
    },
    methods: {
        loginFunc() {
            if (!this.use.userName) {
                Toast('请输入用户名');
                return;
            }
            if (!this.use.passWord) {
                Toast('请输入密码');
                return;
            }
            let paramObj = {
                account:this.use.userName,
                password:this.use.passWord,
            }
            login(paramObj).then(res=>{
                if(res.data.flag){
                    Toast.success('登录成功');
                    //token
                    sessionStorage.setItem('cloud_login_token', res.data.token);
                    //username
                    sessionStorage.setItem('cloud_login_name', res.data.user);
                    // /1个人需求 2公司需求 3资源 4渠道
                    sessionStorage.setItem('cloud_login_user_role',res.data.role);
                    //本地存储 更新header栏 显示状态
                    // this.$store.commit('SET_TOKEN',  res.data.token);
                    //清空表单验证
                    // this.$refs['login-form'].resetFields();
                    //关闭弹窗
                    // this.$store.commit('SET_LOGIN_DIALOG_STATE', false);
                    setTimeout(() => {
                        this.$router.push({path:'/'});
                    }, 1000);
                }else {
                    Toast.fail('用户名或密码错误,请重新输入');
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.login {
    position: relative;
    top:0;
    bottom:0;
    left:0;
    right:0;
    width:100%;
    height:100%;
    background-image: url('http://customer.9hkj.net/chat/img/222.d3bc2b16.png');
    background-size:100% 100%;
    background-repeat: no-repeat;
    .login-box {
        position: absolute;
        bottom: 170px;
        left: 20px;
        width: 90%;
        height: auto;
        border-radius:5px;
        // margin:0 auto;
        box-sizing: border-box;
        padding: 20px 20px;
        background-color: #fff;
    }

    .login-header {
        position: absolute;
        left: 5%;
        top: 130px;
        width: 90%;
        height: 70px;
        text-align:center;
        .login-title{
            font-size:2rem;
            font-weight:600;
        }
        .login-tip{
            font-size:1.5rem;
            margin-top:10px;
        }
    }
}

.login .login-row {
    width: 100%;
    height: auto;
    margin: 0 auto;
}

.login .use {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border: none;
    border-bottom: 1px solid #c1c1d2;
    // background-color:#edf0fa;
    outline: none;
    color: #000;
    // border-radius: 40px;
    box-sizing: border-box;
    padding: 0 10px;
    margin: 10px auto;
    font-size: 16px;

}

input {
    -webkit-appearance: none; //去掉input 在iOS中的默认圆角和内阴影
    -webkit-tap-highlight-color: transparent; //去掉点击时高亮的样式
}

.login .use::placeholder {
    // padding-left:10px;
    color: #666;
    font-size: 15px;
}

.login-btn {
    width: 100%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border: none;
    margin-top: 20px;
    border-radius: 10px;
    font-size: 16px;
    // font-weight: bold;
    letter-spacing: 2px;
    color: #fff;
    background-color: #007AF5;
}
</style>